export default __webpack_public_path__ + "static/media/blog-paver-walkway-011.a5098100.jpg";